import React from "react"
import {
  SimulationBiomassScreen,
  SimulationFeedScreen,
  SimulationHarvestScreen
} from "../../../screens/home/simulation"
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs"
import { Text } from "../../../components"
import { translate } from "../../../i18n"
import { color, nativeBaseTheme } from "../../../theme"
import { Appearance, ViewStyle } from "react-native"

const TAB: ViewStyle = {
  // width: 'auto',
  // paddingHorizontal: 32,
  paddingVertical: 8
}

export type HomeSimulationNavigatorParamList = {
  'Home.Simulation.SimulationBiomassScreen': undefined,
  'Home.Simulation.SimulationFeedScreen': undefined,
  'Home.Simulation.SimulationHarvestScreen': undefined,
}

const Tab = createMaterialTopTabNavigator<HomeSimulationNavigatorParamList>()

export const SimulationStack = {
  index: 0,
  routes: [
    { name: 'Simulation.Stack', state: { index: 0, routes: [{ name: 'Home.Simulation.SimulationHarvestScreen' }] } }
  ]
};

export const SimulationNavigator = () => {
  const colorScheme = "light" || Appearance.getColorScheme()
  return (
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: colorScheme === 'light' ? color.primary : undefined,
        // tabBarScrollEnabled: true,
        tabBarItemStyle: TAB,
        lazy: true,
        lazyPreloadDistance: 1
      }}
    >
      <Tab.Screen
        name="Home.Simulation.SimulationHarvestScreen"
        component={SimulationHarvestScreen}
        options={{
          title: translate('overviewTotalWeightPredictionListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="simulationScreen.HarvestTab"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Simulation.SimulationFeedScreen"
        component={SimulationFeedScreen}
        options={{
          title: translate('overviewHarvestAccumulationWeightActualListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="simulationScreen.FeedTab"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
      <Tab.Screen
        name="Home.Simulation.SimulationBiomassScreen"
        component={SimulationBiomassScreen}
        options={{
          title: translate('overviewFeedAccumulationActualListScreen.title'),
          tabBarLabel({ color, focused }) {
            return <Text
              tx="simulationScreen.BiomassTab"
              preset="title4"
              colorScheme={colorScheme}
              color={focused ? color : nativeBaseTheme.colors[colorScheme]["400"]}
            />
          }
        }}
      />
    </Tab.Navigator>
  )
}
